<template>
  <div v-if="showJob" style="max-width: 960px; position: relative">
    <a :href="onClickDetail()" target="_blank" rel="noopener">
      <v-card outlined class="py-5 px-7 jobLink" elevation="0" style="border: none; height: 100%">
        <FlexRow
          :space="0"
          justify="space-between"
          align="stretch"
          :style="{
            gap: '16px',
            'min-height': '100%',
            'flex-direction': this.$vuetify.breakpoint.xsOnly ? 'column-reverse !important' : undefined
          }"
        >
          <FlexColumn style="min-height: 100%">
            <FlexColumn style="flex: 1">
              <Label :text="job.name" no-of-lines="2" class="jobName" />
              <FlexRow wrap>
                <Chip
                  v-for="occupation in occupations"
                  :key="occupation"
                  size="small" outlined
                  class="mr-2 mb-1"
                >
                  {{occupation}}
                </Chip>
              </FlexRow>
              <FlexRow>
                <div v-if="job.side" class="jobTag side mr-4" style="flex-shrink: 0">副業</div>
                <div v-else class="jobTag mr-4" style="flex-shrink: 0">正社員</div>
                <div v-if="salary" class="jobText mr-4" style="flex-shrink: 0">{{salary}}</div>
                <Label v-if="workPlace(job)" :text="workPlace(job)" no-of-lines="1" class="jobText mr-4" />
              </FlexRow>
              <Label :text="job.detail" no-of-lines="2" class="jobDetail" />
            </FlexColumn>
            
            <FlexRow :space="0" align="center" style="gap: 10px">
              <v-avatar size="30">
                <v-img :src="job.company.logoUrl || 'https://placehold.jp/dedede/ffffff/30x30.png?text=No%20Image'" contain />
              </v-avatar>
              <Label :text="job.company.name" class="companyName subtitle-1 font-weight-bold" />
            </FlexRow>
          </FlexColumn>

          <div style="position: relative">
            <v-img
              :src="image || 'https://placehold.jp/24px/ededed/ffffff/292x202.png?text=Now%20Printing'"
              min-height="202px"
              max-height="202px"
              :min-width="this.$vuetify.breakpoint.xsOnly ? '100%' : '292px'"
              :max-width="this.$vuetify.breakpoint.xsOnly ? '100%' : '292px'"
              style="border: 1px solid #00000005"
            />
            <Button
              icon
              style="position: absolute; right: 8px; top: 8px; background-color: #ffffffbb"
              @click="handleClickFavorite"
            >
              <v-icon v-if="job.isLiked" size="24" color="red">mdi-heart</v-icon>
              <v-icon v-else color="red" size="22">mdi-heart-outline</v-icon>
            </Button>
          </div>

        </FlexRow>
      </v-card>
    </a>
    <v-menu offset-y v-if="isCandidateUser && !isTopPage">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" fab x-small elevation="1" color="white" class="settingIcon" style="background-color: white">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="hiddenJob(job.id, job.isDisplayed)">{{hiddenMessage(job.isDisplayed)}}</v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import ComponentMixin from "../ComponentMixin";
import ApiMixin from "../../ApiMixin";
import { mapGetters } from "vuex";
import Chip from "../atoms/Chip";
import Button from "../atoms/Button";
import FlexRow from '../atoms/FlexRow'
import Label from '../atoms/Label'
import FlexColumn from '../atoms/FlexColumn'

export default {
  mixins: [ComponentMixin, ApiMixin],
  type: "molecule",
  name: "JobOffer",
  props: {
    job: {
      type: Object,
      required: true
    },
    isTopPage: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      showJob: true,
    }
  },
  components: {
    FlexColumn,
    Label,
    FlexRow,
    Button,
    Chip
  },
  beforeMount() {
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    ...mapGetters("user", ["user"]),
    workPlace () {
      return (job) => {
        const prefecture = this.consts.prefectures ? this.consts.prefectures.find(val => val.value === Number(job.prefecture)) : null;
        const prefectureName = prefecture == null ? "" : prefecture.label;
        return `${prefectureName} ${job.address || ""}`;
      }
    },
    salary () {
      if (this.job.side) {
        if (this.job.hourlyWage) {
          return "時間単価 " + this.job.hourlyWage.toString() + " 円"
        }
        return ""
      } else {
        if (this.job.lowerSalary && this.job.upperSalary) {
          return this.job.lowerSalary.toString() + " ~ " + this.job.upperSalary.toString() + "万円"
        } else if (this.job.lowerSalary) {
          return this.job.lowerSalary.toString() + "万円 ~"
        } else if(this.job.upperSalary) {
          return "~ " + this.job.upperSalary.toString() + "万円"
        } else {
          return ""
        }
      }
    },
    image () {
      if (this.job.image1) { return this.job.image1.url }
      if (this.job.image2) { return this.job.image2.url }
      if (this.job.image3) { return this.job.image3.url }
      return ""
    },
    appealPointsChip () {
      return (appealPoints) => {
        if(this.job.side) {
          if(this.consts.jobSideAppealPoint && appealPoints) {
            return this.consts.jobSideAppealPoint.find(val => val.value === appealPoints).label
          }
        } else {
          if(this.consts.companyAppealPoint && appealPoints) {
            return this.consts.companyAppealPoint.find(val => val.value === appealPoints).label
          }
        }
        return null
      }
    },
    hiddenMessage () {
      return (status) => {
        if(status===false) {
          return "非表示を解除"
        }
        return "非表示にする"
      }
    },
    isCandidateUser () {
      return !!this.user.candidate
    },
    occupations() {
      if (this.job.occupations) {
        return this.job.occupations.map(value => this.constsToText(value, this.consts.jobOccupation))
      }
      return []
    }
  },
  methods: {
    onClickDetail () {
      return "/jobs/" + this.job.id;
    },
    hiddenJob (jobId, status) {
      if (status === false){
        this.toggleHiddenJob(jobId, true)
      } else {
        this.toggleHiddenJob(jobId, false)
      }
      this.showJob = false
    },
    handleClickFavorite() {
      if (!this.$auth.isAuthenticated) {
        localStorage.setItem('nishika_redirect', window.location.href)
        this.$auth.loginWithRedirect({
          ui_locales: this.$i18n.locale,
          initialScreen: 'login',
        });
        return;
      }
      this.toggleLikeJob(this.job.id, !this.job.isLiked);
    }
  },
  filters: {
    truncate: function(value, length) {
      if (value == null) {
        return "";
      }
      const omission = "...";
      if (value.length <= length) {
        return value;
      }
      return value.substring(0, length) + omission;
    }
  }
}
</script>

<style scoped lang="sass">
  .jobName
    font-weight: bold
    font-size: 18px
    line-height: 25px

  .jobTag
    color: white
    font-size: 14px
    font-weight: bold
    line-height: 20px
    text-align: center
    background-color: #CBC74E
    width: 60px
    height: 20px

  .jobTag.side
    background-color: #FF5757

  .jobText
    font-size: 14px
    color: #333333

  .jobDetail
    font-size: 14px
    color: #8E8E8E

  .companyName
    font-size: 14px
    color: #333333

  .jobLink
    color: #2f3e6d
    position: relative

  .jobLink:hover
    color: #7aabcc

  .settingIcon
    position: absolute
    right: 12px
    top: 12px

</style>
